import React from "react";
import {Helmet} from "react-helmet";
// import {injectShopContainer} from '../../react/ShopDataContainer'


export default class Base extends React.Component {
  render () {
    // console.log('hi', shop)
    let name = "JoJo's Mediterranean Grill | All Locations"
    let description = "Jojo's Mediterranean Grill offers delicious Mediterranean cuisine with two convenient locations in West Hollywood and North Hollywood. Enjoy a diverse menu of tasty dishes, including a variety of vegetarian options, prepared with the finest ingredients. Join us for a Mediterranean culinary experience like no other!"
    return (
      <Helmet>
          <meta charSet="utf-8" />
          <title>{name}</title>
          <meta name="description"
            content={description} />
          <link rel="canonical" href="https://jojosgrill.com/" />

          <link rel="manifest" href={`${process.env.PUBLIC_URL}/jojos.json`} />
          <link rel="apple-touch-icon" sizes="250x250"
            href={`${process.env.PUBLIC_URL}/jojos.png`} />
          <link rel="apple-touch-icon" sizes="250x250"
            href={`${process.env.PUBLIC_URL}/jojos.png`} />
          <link rel="shortcut icon"
            href={`${process.env.PUBLIC_URL}/jojos.png`}
          />

          {/* Open Graph */}
          <meta property="og:title" content={name} />
          <meta property="og:site_name" content={name} />
          <meta property="og:description" content={description} />
          {/* <meta property="og:image" content={} /> */}
          {/* <meta property="og:url" content="http://euro-travel-example.com/index.htm" /> */}
      </Helmet>


    );
  }
};

// export default injectShopContainer(Base)
